import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type UpdateCustomFieldV3 = OpalApi<'UpdateCustomFieldV3', 200>

export const updateCustomField: UpdateCustomFieldV3 = async (args = {}) => {
  const customFieldId = args.params?.path.custom_field_id

  if (typeof customFieldId !== 'string') {
    throw new Error('Must supply a valid custom_field_id.')
  }

  const url = new URL(
    `/loupe/v3/custom_fields/${customFieldId}`,
    window.location.origin
  )

  return HttpClient()
    .patch(url.toString(), args.requestBody)
    .then((res) => res.data)
}
